<template>
  <div class="pa-6">
    <div v-if="alerts">
      <v-btn color="primary mb-3" @click="clearAllAlerts">очистить всё</v-btn>
      <v-alert
        v-model="alert"
        dense
        elevation="2"
        color="rgba(214, 200, 186, 0.1)"
        border="left"
        v-for="(item, i) in alerts"
        :key="i"
      >
        <v-row dense :class="item.readed_at ? 'text--disabled' : ''">

          <v-col class="text-subtitle-1 pa-0 " cols="3">
            <span>{{ new Date(item.dadd).toLocaleDateString("ru", options) }} </span>
            <span class="text-caption">{{ new Date(item.dadd).toLocaleTimeString("ru", time) }}</span>
          </v-col>

          <v-col class="text-subtitle-1 pa-0" cols="9">
            <span v-if="item.properties && item.properties.referrer && item.properties.referrer.id" @click="getMeeting(item.properties.referrer.id)" class="alert_title">{{ item.alert_title }}</span>
            <span v-else> {{ item.alert_title }}</span>
          </v-col>

          <v-col class="text-subtitle-1 pa-0" cols="12"> {{ item.alert_text }}</v-col>
        </v-row>

        <template v-slot:append>
          <v-icon class="mr-5" color="error" @click="deleteAlertId(item.alert_id)">mdi-close-circle</v-icon>
        </template>

        <template v-slot:close>
          <v-btn v-if="item.properties && item.properties.referrer && item.properties.referrer.id" :data-value="item.properties.referrer.id" text icon @click="getMeeting(item.properties.referrer.id)"
            ><v-icon>mdi-chevron-double-right</v-icon></v-btn>
        </template>
      </v-alert>
    </div>
    <div v-else class="text-h6">Нет данных...</div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "UserNotification",
  data() {
    return {
      alert: true,
    };
  },
  computed: {
    ...mapState("user_notification", ["alerts"]),
    options() {
      let options = { day: "numeric", month: "long", year: "numeric" };
      return options;
    },
    time() {
      let time = { hour: "numeric", minute: "numeric" };
      return time;
    },
  },
  methods: {
    ...mapActions("user_notification", ["getAlerts", "deleteAlert", "clearAlerts"]),
    ...mapActions("meeting", ["getMeetingById"]),
    getMeeting(id) {
      this.$emit("close:notification", false);
      this.getMeetingById(id);
    },
    deleteAlertId(v) {
      this.deleteAlert(v);
      console.log("deleteAlert id:", v);
    },
    clearAllAlerts() {
      this.clearAlerts();
    },
  },
};
</script>

<style lang="scss" scoped>
.v-sheet.v-alert {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
.alert_title:hover {
  cursor: pointer;
  color: #4971d0;
}
</style>
